import { Button } from '@ds';
import { MdOutlineClear } from 'react-icons/md';
import { FilterDropdown } from '@ui';
import { CUSTOMER_ROLES_SELECT_LIST } from '@lp/features/admin/forms';
import { CustomerRoleT, CustomerListFilters } from '@/api/apis/customer';
import { useInfiniteTXCentersListQuery } from '@/queries/tx-centers';
import { useAsyncSearchableList } from '@/hooks/useAsyncSearchableList';
import { useSearchableList } from '@/hooks/useSearchableList';
import { UseFiltersType } from '@/hooks/useFilters';
import { NameByValue } from '@/types';
import { FILTERS_NAMES } from '../config';

type TXUsersInvitedFiltersProps = UseFiltersType<CustomerListFilters>;

export const TXUsersInvitedFilters = ({
  filters,
  hasFilters,
  updateFilters,
  clearFilters,
}: TXUsersInvitedFiltersProps) => {
  const { list: roleList, setSearchValue: onRoleSearch } = useSearchableList(CUSTOMER_ROLES_SELECT_LIST, [
    'name',
    'value',
  ]);

  const {
    list: txCentersList,
    isLoading,
    hasNextPage,
    loadNextPage,
    setSearchValue: onTXCentersSearch,
  } = useAsyncSearchableList({ query: useInfiniteTXCentersListQuery });

  return (
    <div className="flex gap-7 items-center">
      <FilterDropdown<NameByValue<CustomerRoleT>>
        title={FILTERS_NAMES.roles}
        items={roleList}
        selectedKeys={filters.roles || []}
        mode="multiple"
        onSearchValue={onRoleSearch}
        onSelectedKeysChange={(values) => updateFilters(values, 'roles')}
      />
      <FilterDropdown
        title={FILTERS_NAMES.txCenters}
        items={txCentersList as NameByValue<string>[]}
        selectedKeys={filters.txCenters || []}
        mode="multiple"
        hasNextPage={hasNextPage}
        isLoading={isLoading}
        loadNextPage={loadNextPage}
        onSearchValue={onTXCentersSearch}
        onSelectedKeysChange={(values) => updateFilters(values, 'txCenters')}
      />
      {hasFilters && (
        <Button startContent={<MdOutlineClear size={18} />} size="sm" variant="light" onClick={clearFilters}>
          Clear all
        </Button>
      )}
    </div>
  );
};
